import { business } from '@/config/business';
import { seoMeta } from '@/config/seoMeta';

export type RouteSeoEntry = { title: string; description: string };

/** Freshness stamp for sitemap `<lastmod>`; bump it when page content changes. */
export const SITE_LASTMOD = '2026-09-29';

const TITLE_SUFFIX = ` | ${business.brandName}`;

export const routeSeo: Record<string, RouteSeoEntry> = seoMeta;

export const fallbackSeo: RouteSeoEntry = routeSeo['/'];

export const notFoundSeo: RouteSeoEntry = {
  title: `Page not found (404)${TITLE_SUFFIX}`,
  description:
    'We couldn\'t find that page. Return home to explore Alliance Health Physicians\' hospital medicine services, partnerships, and contact options.',
};

export function normalizePathname(pathname: string): string {
  if (!pathname) return '/';
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export function resolveSeo(pathname: string): RouteSeoEntry {
  const path = normalizePathname(pathname);
  return seoMeta[path] ?? fallbackSeo;
}

export function isNotFoundPath(pathname: string): boolean {
  const p = normalizePathname(pathname);
  return seoMeta[p] === undefined;
}

/** Sitemap order: "/" first, then alphabetical. Indexable routes only. */
export function getAllSitemapPaths(): string[] {
  return Object.keys(seoMeta).sort((a, b) => (a === '/' ? -1 : b === '/' ? 1 : a.localeCompare(b)));
}

/** `<lastmod>` for any sitemap path: this site has no dated articles, so one stamp for all. */
export function sitemapLastmod(): string {
  return SITE_LASTMOD;
}
